<template>
  <div>
    <el-drawer
      :visible.sync="drawer"
      direction="rtl"
      show-close
      :size="600"
      :withHeader="false"
      :wrapperClosable="false"
      append-to-body>
      <div class="drawer-box">
        <i class="drawer-icon el-icon-close" @click="hide"></i>
        <div class="drawer-title">
          一、设置许可类型
        </div>
        <div class="type-box">
          <div class="type-btn" :class="permitType === '1' && 'curr-btn'" @click="changeType('1')">
            <i class="el-icon-check" v-if="permitType === '1'"></i>
            非专有许可
          </div>
          <div class="type-btn" style="margin-left:20px;" :class="permitType === '2' && 'curr-btn'" @click="changeType('2')">
            <i class="el-icon-check" v-if="permitType === '2'"></i>
            专有许可
          </div>
        </div>
        <div class="submit-box" v-if="permitType === '2'">
          <div class="submit-notice">
            1. 只能许可给一个人，不能向第三方发放同样的许可；
          </div>
          <div class="submit-notice">
            2. 许可全部权利，包括： 数字作品持有权，实物生产和销售权，网络使用和传播权，非网络使用和传播权，改编及二次创作权；
          </div>
          <div class="submit-notice">
            3. 选择了专有许可，后续不能再进行非专有许可；
          </div>
          <div class="submit-notice">
            4. 专有许可被购买后，不能再次许可。
          </div>
        </div>
        <div class="submit-box" v-if="permitType === '1'">
          <div class="submit-notice">
            1. 可以许可给多个人；
          </div>
          <div class="submit-notice">
            2. 许可部分权利，您可自由设置，默认有数字作品持有权；
          </div>
          <div class="submit-notice">
            3. 专有许可和非专有许可只能二选一进行许可；
          </div>
          <div class="submit-notice">
            4. 非专有许可被全部购买后，可再次许可下一批。
          </div>
        </div>
        <div class="drawer-title">
          二、许可使用渠道{{permitType === '2' ? '（全部权利）' : ''}}
        </div>
        <div class="check-box">
          <div class="check-btn" v-for="item in checkList" :key="item.id" @click="changeText(item)">
            <img src="../../../assets/imgs/upload/choose-wait.png" v-if="!item.isChange && item.canBeUse" class="check-icon" alt="choose">
            <img src="../../../assets/imgs/upload/choose-success.png" v-if="item.isChange && item.canBeUse" class="check-icon" alt="choose">
            <img src="../../../assets/imgs/upload/choose-disable.png" v-if="!item.canBeUse" class="check-icon" alt="choose">
            <span>{{item.text}}</span>
          </div>
        </div>
        <div class="drawer-title">
          三、作品许可数量
        </div>
        <div class="number-input" :class="[noChangeCount, changeCount]" @click="showMaxCountModal">
          <el-input-number size="medium" :disabled="permitType === '2' || submitLock" v-model="totalCount" :min="1" :max="maxCount"></el-input-number>
        </div>
        <div style="margin-top:20px;">
          {{maxCount === 1 ? '仅可许可1枚' : '数量1-' + maxCount + '枚'}}
        </div>
        <div class="drawer-title">
          四、许可时间
        </div>
        <div>
          <el-date-picker
          type="date"
          class="input"
          v-model="startTime"
          :disabled="submitLock"
          :clearable="false"
          @change="changeStar"
          placeholder="起始日期">
          </el-date-picker>
        </div>
        <div style="margin-top:10px;">
          <el-date-picker
          v-model="endTime"
          @change="changeEnd"
          :disabled="submitLock"
          :clearable="false"
          type="date"
          class="input"
          v-if="endTime !== '无限期'"
          placeholder="结束日期">
          </el-date-picker>
          <el-input v-else :value="endTime" style="width:200px;margin-right:20px;" disabled class="input"></el-input>
          <el-checkbox :disabled="submitLock" style="margin-left:30px;" label="无限期" v-model="isLong"></el-checkbox>
        </div>
        <div class="drawer-title">
          五、设置许可价格
        </div>
        <el-input :disabled="submitLock" class="input" v-model="price" placeholder="请设置价格" @change="blurPrice"></el-input>
        <div style="margin-top:20px;">
          价格1-{{maxPrice}}元
        </div>
        <el-button style="margin-top:20px;" class="allow-btn" type="primary" @click="saleGoods">许可作品</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import Detail from '../../../service/detail'
import ChangeRadios from '../../../help/RadioWithCount'
import dayjs from 'dayjs'
export default {
  data() {
    return {
      drawer: false,
      maxCount: 99999,
      sourceFileFlag: '0',
      totalCount: 1,
      price: '',
      maxPrice: 0,
      canBeChange: true,
			canNotChange: false,
      changeRadios:null,
      permitType: '1',
      startTime:'',
      endTime:'',
      isLong: false,
      sellDetailObj: {},
      submitLock: false,
      checkList:[
        {
          id: '1',
          text: '数字作品持有权'
        },
        {
          id: '2',
          text: '实物生产和销售权'
        },
        {
          id: '3',
          text: '网络使用和传播权'
        },
        {
          id: '4',
          text: '非网络使用和传播权'
        },
        {
          id: '5',
          text: '改编及二次创作权'
        }
      ]
    }
  },
  computed: {
    castId () {
      return this.$route.query.castId
    },
    draftId () {
      return this.$route.query.draftId
    },
    changeCount () {
      return this.canBeChange ? 'can-box' : 'false-box'
    },
    noChangeCount () {
      return this.canNotChange ? 'no-false-box' : 'no-can-box'
    }
  },
  watch: {
    isLong (newVal) {
      if (newVal) {
        this.endTime = '无限期'
      } else {
        this.endTime = ''
      }
    },
    permitType: {
      immediate: false,
      handler (persission) {
        if (persission === '1') {// 非专有许可
          this.maxCount = 99999
          this.totalCount = 1
          this.canNotChange = false
          this.canBeChange = true
          this.changeRadios.init('1')
          this.checkList.forEach(item => {
            this.changeRadios.setAuthToNo(item.id, item.id !== '1')
          })
          this.getMostMoneyConfig(30).then(() => {
            this.blurPrice(this.price, false)
          })
        } else {// 专有许可
          this.maxCount = 1
          this.totalCount = 1
          this.canNotChange = false
          this.canBeChange = false
          this.checkList.forEach(item => {
            !item.isChange && this.changeRadios.choose(item.id)
            this.changeRadios.setAuthToNo(item.id)
          })
          this.getMostMoneyConfig(31).then(() => {
            this.blurPrice(this.price, false)
          })
        }
        this.checkList = this.changeRadios.getRadios
      }
    },
    totalCount (count){
      const value = Number(count)
      if (this.maxCount === 1) {
        this.canNotChange = false
        this.canBeChange = false
        return
      }
      if (value >= this.maxCount) {
        this.canBeChange = false
        this.canNotChange = true
      }else if (value <= 1) {
        this.canNotChange = false
        this.canBeChange = true
      } else {
        this.canNotChange = true
        this.canBeChange = true
      }
    }
  },
  mounted () {
    this.getMostMoneyConfig(30)

    Detail.getArtCastDetailById(this.castId).then(res => {
      const list = res.list || []
      if (list.length === 0) return {}
      const id = list[list.length - 1].id
      return Detail.getArtSellDetailById(id)
    }).then(res => {
      this.sellDetailObj = res
    })

    const changeRadios = new ChangeRadios(this.checkList, '1')
    this.changeRadios = changeRadios
    this.changeRadios.setAuthToNo('1')
    this.checkList = this.changeRadios.getRadios
  },
  methods: {
    changeType (type) {
      if (this.getLock(false)) return
      if (this.sellDetailObj.permitType && this.sellDetailObj.permitType.toString() === '1') {
        type === '2' && this.$message.warning('该作品已非专有许可，不支持专有许可')
        return
      }
      this.permitType = type
    },
    showMaxCountModal () {
      if (this.permitType === '2') {
        this.$message.error('专有许可只能许可给一个人')
      }
    },
    getMostMoneyConfig (type) {
      return Detail.getMostMoneyConfig(type).then(configObj => {
        this.maxPrice = configObj
        return configObj
      })
    },
    show () {
      this.drawer = true
    },
    hide () {
      this.drawer = false
    },
    changeText (item) {
      if (this.getLock(false)) return
      this.changeRadios.choose(item.id)
      this.checkList = this.changeRadios.getRadios
    },
    blurPrice (value, isMessage = true) {
      if (!/^[1-9]\d*$/.test(Number(value))) {
        isMessage && this.$message.error('输入的必须是正整数')
        return false
      }
      if (Number(this.maxPrice) < Number(this.price)) {
        this.price = this.maxPrice
        isMessage && this.$message.error('您设置的价格已超限')
        return false
      }
      return true
    },
    getSaleFlag () {
      if (!this.price) {
        this.$message.error('请设置价格')
        return false
      }
      if (!this.startTime) {
        this.$message.error('请设置许可开始时间')
        return false
      }
      if (!this.endTime) {
        this.$message.error('请设置许可结束时间')
        return false
      }
      return true
    },

    getLock (isChangeStatus = true) {
      if (this.submitLock) return true
      isChangeStatus && (this.submitLock = true)
      return false
    },
    async saleGoods () {
      try {
        if (this.getLock()) return
        if (!this.getSaleFlag()) {
          this.submitLock = false
          return
        }
        if (!this.blurPrice(this.price)) {
          this.submitLock = false
          return
        }
        const data = {
          draftId: this.draftId,
          castId: this.castId,
          sourceFileFlag: this.sourceFileFlag,
          totalCount: this.totalCount,
          price: this.price,
          permitType: this.permitType,
          permitStartTime: `${dayjs(this.startTime).year()}-${this.getMonth(dayjs(this.startTime).month() + 1)}-${dayjs(this.startTime).date()}`,
          permitEndTime: this.endTime === '无限期' ? null : `${dayjs(this.endTime).year()}-${this.getMonth(dayjs(this.endTime).month() + 1)}-${dayjs(this.endTime).date()}`,
          sellPermitList: this.checkList.filter(item => item.isChange).map(item => item.text)
        }
        const res = await Detail.createArtSell(data)
        if (res) {
          this.$emit('complate')
        }
        this.submitLock = false
      } catch (error) {
        this.submitLock = false
      }
    },
    getMonth (month) {
      return month < 10 ? "0" + month : month.toString()
    },
    changeStar (val) {
      const nowTime = dayjs()
      const currTime =dayjs(val)
      if (currTime.diff(nowTime) < 0){
        this.startTime = ''
        this.$message.error('开始时间需大于当前时间')
        return
      }
      if (this.endTime && dayjs(this.endTime).diff(currTime) < 0){
        this.startTime = ''
        this.$message.error('结束时间需大于开始时间')
        return
      }
      this.startTime = val
    },
    changeEnd (val) {
      const nowTime = dayjs()
      const currTime =dayjs(val)
      if (currTime.diff(nowTime) < 0){
        this.endTime = ''
        this.$message.error('结束时间需大于当前时间')
        return
      }
      if (this.startTime && dayjs(currTime).diff(this.startTime) < 0){
        this.endTime = ''
        this.$message.error('结束时间需大于开始时间')
        return
      }
      this.endTime = val
    }
  }
}
</script>

<style lang="scss" scoped>
  .submit-box{
    width: calc(100% - 40px);
    border-radius: 10px;
    background-color: $line;
    color: #2DE370;
    padding: 20px;
    box-sizing: border-box;
    margin-top: 20px;
    transition: all .2s;
  }
  .submit-notice{
    font-size: 16px;
    color: $sub-font-color;
    margin-bottom: 20px;
  }
  .drawer-box{
    width: 100%;
    min-height: 100%;
    background-color: $button-bg;
    color: #fff;
    padding: 20px;
    box-sizing: border-box;
  }
  .drawer-title{
    font-size: 18px;
    font-weight: 700;
    margin: 30px 0 10px 0;
  }
  .input::v-deep .el-input__inner{
    background: $line;
    height: 40px;
    width: 200px;
    border: none;
    color: #fff;
  }
  .number-input::v-deep .el-input-number__decrease{
    background-color: #343A3F !important;
    border: none;
    border-radius: 4px;
  } 
  .number-input::v-deep .el-input-number__increase{
    background-color: #2DE370 !important;
    color: #fff;
    border: none;
    position: absolute;
    right: -29px;
    border-radius: 4px;
  }
  .number-input::v-deep .el-input__inner{
    width: 150px;
    margin-left:40px;
    background: $line;
    border: none;
    color: #fff;
  }
  .input.el-input, .input .el-input{
    height: 40px !important;
  }
  .area-input::v-deep .el-textarea__inner{
    line-height: 40px !important;
    color: #fff !important;
    // border: 1px solid #121619;
    border: 1px solid $line;
    box-sizing: border-box;
    border-radius: 2px;
    background-color: $line !important;
  }
  .area-input::v-deep .el-input__count{
    color: #fff !important;
    background-color: $line !important;
  }
  .textFocus::v-deep .el-textarea__inner{
    border: 1px solid #2DE370 !important;
  }
  .input.el-input::v-deep .el-input__inner, .input::v-deep .el-input__inner{
    height: 40px !important;
    line-height: 40px !important;
    color: #fff !important;
    background-color: $line !important;
  }
  .allow-btn{
    width: 140px;
    height: 48px;
  }
  .drawer-icon{
    position: absolute;
    right: 30px;
    top: 30px;
    cursor: pointer;
    font-size: 30px;
  }
  .type-box{
    width: 100%;
    height: 40px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .type-btn{
    width: 120px;
    height: 100%;
    border-radius: 20px;
    background: $line;
    line-height: 40px;
    text-align: center;
    cursor: pointer;
    transition: all .2s;
  }
  .check-box{
    margin-top: 10px;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
  }
  .curr-btn{
    background-color: #2DE370 !important;
  }
  .check-icon{
    width: 24px;
    height: 24px;
    margin-right: 5px;
    position: relative;
    top: 5px;
  }
  .check-btn{
    padding: 10px;
    border-radius: 4px;
    margin-right: 10px;
    cursor: pointer;
  }
  .no-can-box::v-deep .el-input-number__decrease{
    color: #fff !important;
    background-color: #343A3F !important;
  }
  .no-false-box::v-deep .el-input-number__decrease{
    background-color: #2DE370 !important;
    color: #fff !important;
  }
  .can-box::v-deep .el-input-number__increase{
    color: #fff !important;
    background-color: #2DE370 !important;
  }
  .false-box::v-deep .el-input-number__increase{
    color: #fff !important;
    background-color: #343A3F !important;
  }
</style>